
<template>
  <div class="container">
    <el-row>
      <el-col class="design-title" :span="9">
        <div class="english">PRODUCTSERIES</div>
        <div class="chinese">新品推荐</div>
      </el-col>
      <el-col :span="13">
        <div class="products-container">
          <div
            class="item-container"
            v-for=" (item, index) in this.products"
            v-bind:key="index"
            @click="handtodetil(item)"
          >
            <el-image :src="item.image" />
            <div class="title">{{item.storeName}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22">
        <div class="evenmore" @click="goshoplist()">
          查看更多
          <i class="el-icon-arrow-right" style="margin-left: 248px;"></i>
        </div>
      </el-col>
    </el-row>
  </div>
  <!-- <div class="recommend">
      <div class="recommend_titleft">PRODUCTSERIES</div>
      <p class="recommend_titright">新品推荐</p>
      <ul>
        <li v-for=" (item, index) in this.products" v-bind:key="index" @click="handtodetil(item)">
          <img :src="item.image" >
          <div class="titpic">{{item.storeName}}</div>
        </li>
      </ul>
      <div class="recommend_evenmore" @click="goshoplist()">查看更多 <i class="el-icon-arrow-right" style="margin-left: 248px;"></i></div>
  </div>-->
</template>

<script>
export default {
  // eslint-disable-next-line standard/object-curly-even-spacing
  props: ['products'],
  // props: { products: Array},
  created() {},
  mounted() {},
  data() {
    return {
      active: ''
    }
  },
  watch: {
    $route(to, from) {
      console.log('to')
    },
    obj: {}
  },
  methods: {
    handtodetil: function (nownode) {
      this.$router.push({
        path: '/productDetail',
        query: {
          productId: nownode.id,
          type: 0
        }
      })
      // /productDetail
    },
    mouseOver: function () {
      // eslint-disable-next-line no-caller
      var event = window.event || arguments.callee.caller.arguments[0]
      event.target.className = 'hoverstyle'
    },
    goshoplist() {
      this.$router.push({
        path: '/indexpage/productlist'
        // query: {
        //   productId: itemobj
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 96px;
  padding-bottom: 72px;
  background-color: #f8f8f8;
  .design-title {
    position: relative;
    .english {
      width: 150px;
      font-size: 18px;
      font-family: PingFang;
      // font-weight: bold;
      color: #898989;
      line-height: 27px;
      border-top: 2px solid #aaaaaa;
      position: relative;
      top: 66px;
      left: 322px;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg); /* Opera */
    }
    .chinese {
      width: 28px;
      // height: 141px;
      font-size: 30px;
      font-family: PingFang;
      // font-weight: bold;
      color: #000000;
      line-height: 38px;
      position: relative;
      top: -30px;
      left: 425px;
    }
  }

  .products-container {
    text-align: center;
    display: grid;
    grid-column-gap: 16px;
    grid-row-gap: 96px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    .item-container {
      background-color: white;
      padding: 16px;
    }
    .title {
      margin-top: 8px;
    }
  }

  .evenmore {
    font-size: 18px;
    line-height: 30px;
    width: 351px;
    height: 43px;
    border-bottom: 1px solid #aaaaaa;
    float: right;
    cursor: pointer;
    margin-top: 24px;
  }
}
.recommend {
  width: 100%;
  height: 1030px;
  // height: 424px;
  background-color: #f8f8f8;
  ul {
    width: 980px;
    height: 100%;
    position: relative;
    top: -153px;
    left: 596px;
    li {
      width: 307px;
      height: 307px;
      background-color: #fff;
      float: left;
      margin-left: 16px;
      margin-top: 106px;
      cursor: pointer;
      img {
        width: 240px;
        height: 240px;
        position: relative;
        left: 50%;
        top: 17px;
        transform: translateX(-50%);
      }
      .titpic {
        width: 100%;
        position: relative;
        left: 0px;
        top: 29px;
        text-align: center;
      }
    }
  }
  .recommend_titleft {
    width: 150px;
    font-size: 18px;
    font-family: PingFang;
    // font-weight: bold;
    color: #898989;
    line-height: 27px;
    border-top: 2px solid #aaaaaa;
    position: relative;
    top: 192px;
    left: 322px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
    -o-transform: rotate(90deg); /* Opera */
  }
  .recommend_titright {
    width: 28px;
    // height: 141px;
    font-size: 30px;
    font-family: PingFang;
    // font-weight: bold;
    color: #000000;
    line-height: 38px;
    position: relative;
    top: 100px;
    left: 425px;
  }
  .recommend_evenmore {
    font-size: 18px;
    line-height: 30px;
    width: 351px;
    height: 43px;
    border-bottom: 1px solid #aaaaaa;
    position: relative;
    top: -300px;
    left: 1212px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/newrecommend.vue